import { Bed, Bath, Tv, Wifi, Car } from "lucide-react";
import RoomDetail from "./RoomDetail";
import tripleRoom1 from "@/assets/triple-room-new-1.jpeg";
import tripleRoom2 from "@/assets/triple-room-new-2.jpeg";
import tripleRoom3 from "@/assets/triple-room-new-3.jpeg";
import tripleRoom4 from "@/assets/triple-room-new-4.jpeg";
import tripleRoom5 from "@/assets/triple-room-new-5.jpeg";
import tripleRoom6 from "@/assets/triple-room-new-6.jpeg";
import tripleRoom7 from "@/assets/triple-room-new-7.jpeg";
import tripleRoom8 from "@/assets/triple-room-new-8.jpeg";
import tripleRoom9 from "@/assets/triple-room-new-9.jpeg";
import { useLanguage } from "@/i18n/LanguageContext";
import { useRoomContent } from "@/hooks/useRoomContent";

const TripleRoom = () => {
  const { t } = useLanguage();
  const { current } = useRoomContent("triple");
  const rd = t.roomData;
  const images = [
    { src: tripleRoom1, alt: current?.title || t.subpageHeroes.tripleRoom.title },
    { src: tripleRoom4, alt: "Doppelbett & Einzelbett" },
    { src: tripleRoom5, alt: "Doppelbett & Einzelbett weiss" },
    { src: tripleRoom9, alt: "Zimmerübersicht" },
    { src: tripleRoom3, alt: "Zimmer mit Bad" },
    { src: tripleRoom2, alt: "Bad & Dusche" },
    { src: tripleRoom8, alt: "Schminktisch & TV" },
    { src: tripleRoom7, alt: "Schreibtisch" },
    { src: tripleRoom6, alt: "Schrank & Safe" },
  ];
  const amenityLabels = current?.amenities?.length ? current.amenities : rd.triple.amenities;
  const amenities = amenityLabels.map((label, i) => ({
    icon: [Bed, Bath, Tv, Wifi, Car][i],
    label,
  }));
  return (
    <RoomDetail
      title={current?.title || t.subpageHeroes.tripleRoom.title}
      subtitle={current?.description || t.subpageHeroes.tripleRoom.subtitle}
      images={images}
      amenities={amenities}
      features={rd.features}
      highlight={{ image: tripleRoom3, title: current?.highlight || rd.triple.highlight, subtitle: current?.highlightSub || rd.triple.highlightSub }}
    />
  );
};

export default TripleRoom;
